import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { IClassifier } from '../../../models/Classifier';
import { IStudentCourseEqualizationFile, IStudentCourseEqualizationInner } from '../../../models/StudentCourseEqualization';
import { AppService } from '../../../services/app.service';
import { StudentCourseEqualizationService } from '../../../services/student-course-equalization.service';
import { ITableColumn } from '../../../shared/table/table.component';
import { util } from '../shared';

export interface IInnerCourseOptions {
    grades: IClassifier[];
    decisions: IClassifier[];
    defaultGradeId?: string;
}

@Component({
    selector: 'app-student-course-equalization-inner',
    templateUrl: './student-course-equalization-inner.component.html',
    styleUrls: ['../student-course-equalization.component.scss']
})
export class StudentCourseEqualizationInnerComponent {
    constructor(
        private app: AppService,
        private service: StudentCourseEqualizationService,
        private activeModal: NgbActiveModal
    ) { }

    @Input() set data(value: { course: IStudentCourseEqualizationInner, options: IInnerCourseOptions }) {
        this.course = value.course;
        this.model = JSON.parse(JSON.stringify(value.course));

        this.gradeOptions = value.options.grades || [];
        this.decisionOptions = value.options.decisions || [];

        this.grade = this.gradeOptions.find(t => t.Id == this.model.GradeId);
        this.decision = this.decisionOptions.find(t => t.Id == this.model.ApprovalDecisionId);

        this.onDecisionChange();

        if (!this.grade && !this.model.IsEqualizedWithNoGrade) {
            this.grade = this.gradeOptions.find(t => t.Id == value.options.defaultGradeId);
        }
    }

    readonly outerColumns: ITableColumn[] = [
        { label: 'studentCourseEqualization_lblInnerPrevCompletedCourse' },
        { label: 'studentCourseEqualization_lblEcts' },
        { label: 'studentCourseEqualization_lblGrade' },
        { label: 'studentCourseEqualization_lblAttachments' }
    ];

    readonly util = util;

    decision: IClassifier;
    grade: IClassifier;

    model: IStudentCourseEqualizationInner = <IStudentCourseEqualizationInner>{};
    gradeOptions: IClassifier[] = [];
    decisionOptions: IClassifier[] = [];

    get isFullPass() {
        return this.decision?.Code == 'PassFull';
    }

    get isPartialPass() {
        return this.decision?.Code == 'PassPartial';
    }

    get isNoPass() {
        return this.decision?.Code == 'Fail';
    }

    private course: IStudentCourseEqualizationInner;

    ok() {
        this.model.Grade = this.grade?.Value;
        this.model.GradeId = this.grade?.Id;
        this.model.GradeValue = this.grade?.Code;

        this.model.ApprovalDecision = this.decision.Value;
        this.model.ApprovalDecisionId = this.decision.Id;
        this.model.ApprovalDecisionCode = this.decision.Code;

        this.activeModal.close({
            model: this.model
        });
    }

    cancel() {
        this.activeModal.dismiss();
    }

    downloadAttachment(attachment: IStudentCourseEqualizationFile) {
        util.downloadAttachment(this.app, this.service, attachment);
    }

    onEqualizeWithNoGrade(checked: boolean) {
        if (checked) {
            this.grade = undefined;
        }
    }

    onDecisionChange() {
        if (!this.isPartialPass) {
            this.model.IsEqualizedWithNoGrade = false;
        }

        if (this.isFullPass) {
            this.model.AcquireEcts = 0;
        } else if (this.isNoPass) {
            this.grade = undefined;
            this.model.AcquireEcts = this.course.Ects;
        }
    }
}
